import Service from './Service';
import type TokenizedApi from '../TokenizedApi';

/** @internal */
class PersistentStorage extends Service {
  constructor(tokenizedApi: TokenizedApi) {
    super(tokenizedApi);
  }

  makeFullItemName(name: string) {
    if (this.tokenizedApi.sessionId) {
      return `${this.tokenizedApi.sessionId}:${name}`;
    }
    return name;
  }

  getItem(name: string) {
    return window.sessionStorage.getItem(this.makeFullItemName(name));
  }

  setItem(name: string, value: string) {
    return window.sessionStorage.setItem(this.makeFullItemName(name), value);
  }

  removeItem(name: string) {
    return window.sessionStorage.removeItem(this.makeFullItemName(name));
  }

  getGlobalItem(name: string) {
    return window.localStorage.getItem(name);
  }

  setGlobalItem(name: string, value: string) {
    return window.localStorage.setItem(name, value);
  }

  removeGlobalItem(name: string) {
    return window.localStorage.removeItem(name);
  }
}

export default PersistentStorage;
